import { Status } from "./Status";


export class CustomerStatusSmartEnum {
    static IsActive = new Status("Active", 1, "pill--green");
    static IsInactive = new Status("Inactive", 2, "pill--grey");
    static PendingDeletion = new Status("Pending Deletion", 3, "pill--orange");
    static Deleted = new Status("Deleted", 4, "pill--red");

    public static getName() {
        // Cannot use this.name as it will be the minified value in production
        return "CustomerStatusSmartEnum";
    }
}
